import Vue from 'vue'

const EventsBus = new Vue()

export default EventsBus
